var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('v-app',{attrs:{"dark":""}},[_c('v-main',{attrs:{"dark":""}},[_c('router-view',{attrs:{"user":_vm.user},on:{"updateUser":_vm.updateUser}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }